const locales: string[] = [
  'de'
];

const defaultLocale = 'de';

export const languageConfig = {
  defaultLocale,
  locales
};
